import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

/**
 * This function checks if a customer has filled out all necessary contact information.
 *
 * @param {Object} customer - The customer object.
 * @param {string} customer.firstName - The customer's first name.
 * @param {string} customer.lastName - The customer's last name.
 * @param {string} customer.email - The customer's email.
 * @param {string} customer.dob - The customer's date of birth.
 * @param {string} customer.phone - The customer's phone number.
 * @param {Object} customer.address - The customer's address.
 * @param {string} customer.address.line1 - The first line of the customer's address.
 * @param {string} customer.address.city - The city of the customer's address.
 * @param {string} customer.address.state - The state of the customer's address.
 * @param {string} customer.address.postalCode - The postal code of the customer's address.
 *
 * @returns {boolean} Returns true if all contact information is filled out, false otherwise.
 */
const getHasFilledOutContact = (customer) => {
	const propsToCheck = [
		'firstName',
		'lastName',
		'email',
		'dob',
		'phone',
		'address.line1',
		'address.city',
		'address.state',
		'address.postalCode',
	];
	const hasMissingProps = Boolean(propsToCheck.find((prop) => isEmpty(get(customer, prop))));

	return !hasMissingProps;
};

export default getHasFilledOutContact;
